import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { MemoizedDefaultChip } from "../chip/ChipRenderer.js";
import { ChipType, ChipVariant } from "../chip/types.js";
import "../chip/Chips.js";
import "../chip/ListWithChipTooltip.js";
import "../chip/SquaredChipList.js";
import "../icons/Icon.js";
import "../icons/ExpandMoreIcon.js";
const useCircularProgressWithLabelStyles = makeStyles()((theme) => ({
  circularProgressWithLabelContainer: {
    position: "relative",
    display: "inline-flex"
  },
  circularProgressWithLabelLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(2)
  },
  circularProgressWithLabelRoot: {
    position: "relative"
  },
  circularProgressWithLabelBottom: {
    color: theme.palette.secondary.light
  },
  circularProgressWithLabelTop: {
    color: theme.palette.primary.main,
    position: "absolute",
    left: 0
  },
  circularProgressWithLabelCircle: {
    strokeLinecap: "round"
  }
}));
const CircularProgressWithLabel = (props) => {
  const { classes } = useCircularProgressWithLabelStyles();
  const { totalItemCount, "data-testid": dataTestId, processedItemLabel, ...otherProps } = props;
  const processedItemCount = Math.round(otherProps.value * totalItemCount / 100);
  return /* @__PURE__ */ React.createElement(Box, { "data-testid": dataTestId, className: classes.circularProgressWithLabelContainer }, /* @__PURE__ */ React.createElement(Box, { className: classes.circularProgressWithLabelLabel }, totalItemCount ? /* @__PURE__ */ React.createElement(
    MemoizedDefaultChip,
    {
      value: `${processedItemCount} / ${totalItemCount} ${processedItemLabel}`,
      variant: ChipVariant.Disabled,
      type: ChipType.Status
    }
  ) : null), /* @__PURE__ */ React.createElement(Box, { className: classes.circularProgressWithLabelRoot }, /* @__PURE__ */ React.createElement(
    CircularProgress,
    {
      variant: "determinate",
      className: classes.circularProgressWithLabelBottom,
      thickness: 2,
      ...otherProps,
      value: 100
    }
  ), /* @__PURE__ */ React.createElement(
    CircularProgress,
    {
      className: classes.circularProgressWithLabelTop,
      classes: {
        circle: classes.circularProgressWithLabelCircle
      },
      variant: "determinate",
      thickness: 2,
      ...otherProps
    }
  )));
};
export {
  CircularProgressWithLabel
};
//# sourceMappingURL=CircularProgressWithLabel.js.map
